import { render, staticRenderFns } from "./TeamWidget.vue?vue&type=template&id=5a23f024&"
import script from "./TeamWidget.vue?vue&type=script&lang=js&"
export * from "./TeamWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports